var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "SearchChat" } }, [
    !_vm.$store.state.chat.isMobileMode
      ? _c(
          "div",
          {
            staticClass: "panel panel-default",
            staticStyle: { "margin-bottom": "unset" }
          },
          [
            _c("div", { staticClass: "panel-heading web-ui" }),
            _vm._v(" "),
            _c("div", { staticClass: "panel-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-12" }, [
                  _c(
                    "div",
                    { staticClass: "uk-margin-small-bottom" },
                    _vm._l(_vm.listTagSearch, function(tag) {
                      return _c(
                        "span",
                        { key: tag, staticClass: "tagAll" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                closable: "",
                                "disable-transitions": false
                              },
                              on: {
                                close: function($event) {
                                  return _vm.handleClose(tag)
                                }
                              }
                            },
                            [_vm._v(_vm._s(tag))]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  !_vm.searchTags
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search,
                            expression: "search"
                          }
                        ],
                        ref: "txtSearch",
                        staticClass: "search-ui",
                        staticStyle: { width: "85%" },
                        attrs: {
                          type: "text",
                          placeholder: "Search for customers"
                        },
                        domProps: { value: _vm.search },
                        on: {
                          keyup: [
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.enterSearch($event)
                            },
                            function($event) {
                              if (
                                $event.ctrlKey ||
                                $event.shiftKey ||
                                $event.altKey ||
                                $event.metaKey
                              ) {
                                return null
                              }
                              return _vm.chekSearch($event)
                            }
                          ],
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.search = $event.target.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.searchTags
                    ? _c(
                        "button",
                        {
                          staticClass: "el-button el-button--primary",
                          staticStyle: {
                            padding: "17px 16px",
                            "border-radius": "2px",
                            "font-size": "17px"
                          },
                          attrs: { type: "button" },
                          on: { click: _vm.clearSearchWithActive }
                        },
                        [_vm._v("\n            All\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tag-buttons" },
                    _vm._l(["paid", "nopaid"], function(tag) {
                      return _vm.searchTags
                        ? _c(
                            "button",
                            {
                              key: tag,
                              class: {
                                active: _vm.listTagSearch.includes(tag)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleTag(tag)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(tag) +
                                  "(" +
                                  _vm._s(
                                    tag == "paid"
                                      ? parseFloat(
                                          _vm.$store.state.chat.paidCountAll
                                        ).toLocaleString("en-US")
                                      : parseFloat(
                                          _vm.$store.state.chat.unpaidCountAll
                                        ).toLocaleString("en-US")
                                  ) +
                                  ") \n            "
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.searchTags
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.inputTags,
                            expression: "inputTags"
                          }
                        ],
                        staticClass: "search-tag",
                        attrs: { type: "text", placeholder: "Search for tags" },
                        domProps: { value: _vm.inputTags },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleInputConfirm($event)
                          },
                          blur: _vm.handleInputConfirm,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.inputTags = $event.target.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "pa-sm",
                      staticStyle: {
                        "font-size": "18px",
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                        "margin-bottom": "unset"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "gutter-sm",
                          staticStyle: { "margin-right": "2px" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: { "margin-left": "4px" }
                            },
                            [
                              _c("label", [_vm._v("ลูกค้า")]),
                              _vm._v(" "),
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.customerSelf,
                                      expression: "customerSelf"
                                    }
                                  ],
                                  attrs: { type: "radio", name: "mycustomer" },
                                  domProps: {
                                    value: true,
                                    checked: _vm._q(_vm.customerSelf, true)
                                  },
                                  on: {
                                    click: _vm.handleSelectFilter,
                                    change: function($event) {
                                      _vm.customerSelf = true
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n                  Filter\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.customerSelf,
                                      expression: "customerSelf"
                                    }
                                  ],
                                  attrs: { type: "radio", name: "mycustomer" },
                                  domProps: {
                                    value: false,
                                    checked: _vm._q(_vm.customerSelf, false)
                                  },
                                  on: {
                                    click: _vm.handleSelectFilter,
                                    change: function($event) {
                                      _vm.customerSelf = false
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n                  All\n                "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.customerSelf,
                                  expression: "customerSelf"
                                }
                              ],
                              staticClass: "row",
                              staticStyle: { "margin-left": "4px" }
                            },
                            [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.customerTeams,
                                      expression: "customerTeams"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    name: "customerTeam",
                                    value: "-"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.customerTeams, "-")
                                  },
                                  on: {
                                    click: _vm.handleSelectFilter,
                                    change: function($event) {
                                      _vm.customerTeams = "-"
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n                  ของฉัน\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.customerTeams,
                                      expression: "customerTeams"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    name: "customerTeam",
                                    value: "a"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.customerTeams, "a")
                                  },
                                  on: {
                                    click: _vm.handleSelectFilter,
                                    change: function($event) {
                                      _vm.customerTeams = "a"
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n                  Team A\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.customerTeams,
                                      expression: "customerTeams"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    name: "customerTeam",
                                    value: "b"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.customerTeams, "b")
                                  },
                                  on: {
                                    click: _vm.handleSelectFilter,
                                    change: function($event) {
                                      _vm.customerTeams = "b"
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n                  Team B\n                "
                                )
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "gutter-sm",
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "flex-wrap": "wrap",
                            width: "125px"
                          }
                        },
                        [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.searchTags,
                                  expression: "searchTags"
                                }
                              ],
                              staticClass: "uk-radio",
                              attrs: { type: "radio", name: "Select01" },
                              domProps: {
                                value: true,
                                checked: _vm._q(_vm.searchTags, true)
                              },
                              on: {
                                change: function($event) {
                                  _vm.searchTags = true
                                }
                              }
                            }),
                            _vm._v("\n                Tag\n              ")
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.searchTags,
                                  expression: "searchTags"
                                }
                              ],
                              staticClass: "uk-radio",
                              attrs: { type: "radio", name: "Select01" },
                              domProps: {
                                value: false,
                                checked: _vm._q(_vm.searchTags, false)
                              },
                              on: {
                                change: function($event) {
                                  _vm.searchTags = false
                                }
                              }
                            }),
                            _vm._v("\n                All\n              ")
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.notResponse,
                                  expression: "notResponse"
                                }
                              ],
                              staticClass: "uk-checkbox",
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.notResponse)
                                  ? _vm._i(_vm.notResponse, null) > -1
                                  : _vm.notResponse
                              },
                              on: {
                                click: _vm.handleSelectFilter,
                                change: function($event) {
                                  var $$a = _vm.notResponse,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.notResponse = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.notResponse = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.notResponse = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(" รอตอบกลับ")])
                          ])
                        ]
                      )
                    ]
                  )
                ])
              ])
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$store.state.chat.isMobileMode
      ? _c("div", { staticClass: "search-chat" }, [
          _c(
            "div",
            { staticClass: "uk-margin-small-bottom" },
            _vm._l(_vm.listTagSearch, function(tag) {
              return _c(
                "span",
                { key: tag, staticClass: "tagAll" },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: { closable: "", "disable-transitions": false },
                      on: {
                        close: function($event) {
                          return _vm.handleClose(tag)
                        }
                      }
                    },
                    [_vm._v(_vm._s(tag))]
                  )
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          !_vm.searchTags
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.search,
                    expression: "search"
                  }
                ],
                ref: "txtSearch",
                staticClass: "search-ui",
                staticStyle: { width: "86%" },
                attrs: {
                  type: "text",
                  placeholder: "Search for customers name..."
                },
                domProps: { value: _vm.search },
                on: {
                  keyup: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.enterSearch($event)
                    },
                    function($event) {
                      if (
                        $event.ctrlKey ||
                        $event.shiftKey ||
                        $event.altKey ||
                        $event.metaKey
                      ) {
                        return null
                      }
                      return _vm.chekSearch($event)
                    }
                  ],
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.search = $event.target.value
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.searchTags
            ? _c(
                "button",
                {
                  staticClass: "el-button el-button--primary",
                  staticStyle: {
                    padding: "17px 16px",
                    "border-radius": "2px",
                    "font-size": "17px"
                  },
                  attrs: { type: "button" },
                  on: { click: _vm.clearSearchWithActive }
                },
                [_vm._v("\n      All\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tag-buttons" },
            _vm._l(["paid", "nopaid"], function(tag) {
              return _vm.searchTags
                ? _c(
                    "button",
                    {
                      key: tag,
                      class: { active: _vm.listTagSearch.includes(tag) },
                      on: {
                        click: function($event) {
                          return _vm.toggleTag(tag)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "(" +
                          _vm._s(
                            tag == "paid"
                              ? parseFloat(
                                  _vm.$store.state.chat.paidCountAll
                                ).toLocaleString("en-US")
                              : parseFloat(
                                  _vm.$store.state.chat.unpaidCountAll
                                ).toLocaleString("en-US")
                          ) +
                          ") \n            "
                      )
                    ]
                  )
                : _vm._e()
            }),
            0
          ),
          _vm._v(" "),
          _vm.searchTags
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputTags,
                    expression: "inputTags"
                  }
                ],
                staticClass: "search-tag",
                attrs: { type: "text", placeholder: "Search for tags" },
                domProps: { value: _vm.inputTags },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleInputConfirm($event)
                  },
                  blur: _vm.handleInputConfirm,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.inputTags = $event.target.value
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "gutter-sm",
              staticStyle: { margin: "8px 0px", "font-size": "22px" }
            },
            [
              _c(
                "div",
                { staticClass: "row", staticStyle: { "margin-left": "4px" } },
                [
                  _c("label", [_vm._v("ลูกค้า")]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customerSelf,
                          expression: "customerSelf"
                        }
                      ],
                      attrs: { type: "radio", name: "mycustomer" },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.customerSelf, true)
                      },
                      on: {
                        click: _vm.handleSelectFilter,
                        change: function($event) {
                          _vm.customerSelf = true
                        }
                      }
                    }),
                    _vm._v("\n                  Filter\n                ")
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customerSelf,
                          expression: "customerSelf"
                        }
                      ],
                      attrs: { type: "radio", name: "mycustomer" },
                      domProps: {
                        value: false,
                        checked: _vm._q(_vm.customerSelf, false)
                      },
                      on: {
                        click: _vm.handleSelectFilter,
                        change: function($event) {
                          _vm.customerSelf = false
                        }
                      }
                    }),
                    _vm._v("\n                  All\n                ")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.customerSelf,
                      expression: "customerSelf"
                    }
                  ],
                  staticClass: "row",
                  staticStyle: { "margin-left": "4px" }
                },
                [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customerTeams,
                          expression: "customerTeams"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        name: "customerTeam",
                        value: "-"
                      },
                      domProps: { checked: _vm._q(_vm.customerTeams, "-") },
                      on: {
                        click: _vm.handleSelectFilter,
                        change: function($event) {
                          _vm.customerTeams = "-"
                        }
                      }
                    }),
                    _vm._v("\n                  ของฉัน\n                ")
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customerTeams,
                          expression: "customerTeams"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        name: "customerTeam",
                        value: "a"
                      },
                      domProps: { checked: _vm._q(_vm.customerTeams, "a") },
                      on: {
                        click: _vm.handleSelectFilter,
                        change: function($event) {
                          _vm.customerTeams = "a"
                        }
                      }
                    }),
                    _vm._v("\n                  Team A\n                ")
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customerTeams,
                          expression: "customerTeams"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        name: "customerTeam",
                        value: "b"
                      },
                      domProps: { checked: _vm._q(_vm.customerTeams, "b") },
                      on: {
                        click: _vm.handleSelectFilter,
                        change: function($event) {
                          _vm.customerTeams = "b"
                        }
                      }
                    }),
                    _vm._v("\n                  Team B\n                ")
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "gutter-sm",
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "flex-wrap": "wrap",
                width: "125px"
              }
            },
            [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchTags,
                      expression: "searchTags"
                    }
                  ],
                  staticClass: "uk-radio",
                  attrs: { type: "radio", name: "Select01" },
                  domProps: {
                    value: true,
                    checked: _vm._q(_vm.searchTags, true)
                  },
                  on: {
                    change: function($event) {
                      _vm.searchTags = true
                    }
                  }
                }),
                _vm._v("\n                Tag\n              ")
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchTags,
                      expression: "searchTags"
                    }
                  ],
                  staticClass: "uk-radio",
                  attrs: { type: "radio", name: "Select01" },
                  domProps: {
                    value: false,
                    checked: _vm._q(_vm.searchTags, false)
                  },
                  on: {
                    change: function($event) {
                      _vm.searchTags = false
                    }
                  }
                }),
                _vm._v("\n                All\n              ")
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.notResponse,
                      expression: "notResponse"
                    }
                  ],
                  staticClass: "uk-checkbox",
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.notResponse)
                      ? _vm._i(_vm.notResponse, null) > -1
                      : _vm.notResponse
                  },
                  on: {
                    click: _vm.handleSelectFilter,
                    change: function($event) {
                      var $$a = _vm.notResponse,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.notResponse = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.notResponse = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.notResponse = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(" รอตอบกลับ")])
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.searchCustomers.length > 0
      ? _c(
          "div",
          {
            staticStyle: { position: "relative" },
            attrs: { id: "contact-cus" }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.search != "",
                    expression: "search != ''"
                  }
                ],
                staticClass: "header-group"
              },
              [_vm._v("Contact Customer")]
            ),
            _vm._v(" "),
            _c(
              "scroll-box",
              {
                staticClass: "customer-showScoll",
                style: {
                  height:
                    _vm.searchCustomers.length > 8 &&
                    _vm.searchCustomersMessage.length > 0
                      ? "calc(77vh - 200px)"
                      : _vm.search != ""
                      ? "calc(153vh - 244px)"
                      : "calc(153vh - 200px)",
                  overflowY: _vm.searchCustomers.length > 8 ? "scroll" : "none"
                },
                attrs: { id: "listChat", "bottom-offset": 130 },
                on: { "on-scroll-bottom": _vm.loadMoreCustomer }
              },
              [
                _c(
                  "ul",
                  {
                    staticClass: "list-group",
                    class: { "on-mobile": _vm.$store.state.chat.isMobileMode }
                  },
                  _vm._l(_vm.searchCustomers, function(item) {
                    return _c(
                      "li",
                      {
                        key: item.custId,
                        staticClass: "list-group-item",
                        class: { active: _vm.isActive(item) },
                        on: {
                          click: function($event) {
                            return _vm.$store.dispatch(
                              "chat/setActiveChatCustumer",
                              item
                            )
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "uk-grid-small uk-flex-middle",
                            attrs: { "uk-grid": "" }
                          },
                          [
                            _c("div", { staticClass: "uk-width-auto" }, [
                              _c("div", { staticClass: "customer-profile" }, [
                                _c("img", {
                                  staticClass: "uk-border-circle",
                                  staticStyle: {
                                    width: "54px",
                                    height: "54px"
                                  },
                                  attrs: {
                                    width: "64",
                                    height: "64",
                                    src:
                                      "https://cdnx.softsq.com/thumb/unsafe/84x84/" +
                                      encodeURIComponent(
                                        encodeURIComponent(item.custImage)
                                      ),
                                    "data-src": "holder.js/64x64",
                                    "data-holder-rendered": "true"
                                  }
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "customer-source",
                                  attrs: {
                                    src:
                                      "/static/" +
                                      (item.channelName == "Line OA"
                                        ? "line_oa"
                                        : item.customerSource || "line") +
                                      "_icon_16.png"
                                  }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "uk-width-expand" }, [
                              _c("div", {
                                directives: [
                                  {
                                    name: "time",
                                    rawName: "v-time",
                                    value: item.latestUpdated,
                                    expression: "item.latestUpdated"
                                  }
                                ],
                                staticClass: "list-time"
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.count != 0,
                                      expression: "item.count != 0"
                                    }
                                  ],
                                  staticClass: "badge msg-unread"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.count) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h4",
                                {
                                  staticClass:
                                    "uk-margin-remove-bottom uk-margin-remove-top"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        item.custNameNew == ""
                                          ? item.custName
                                          : item.custNameNew
                                      ) +
                                      "\n                "
                                  ),
                                  item.hold
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticStyle: {
                                            height: "22px",
                                            transform: "translateY(-2px)"
                                          },
                                          attrs: {
                                            size: "mini",
                                            type: "warning",
                                            effect: "dark"
                                          }
                                        },
                                        [_vm._v("Hold")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class: {
                                    "box-arrow-left": item.sender == "C",
                                    "box-arrow-right": item.sender == "R",
                                    "bot-message":
                                      item.isBot ||
                                      (item.sender == "R" &&
                                        item.latestMsg.startsWith("/"))
                                  },
                                  staticStyle: { "margin-bottom": "10px" }
                                },
                                [
                                  _c("p", {
                                    directives: [
                                      {
                                        name: "lastmsg",
                                        rawName: "v-lastmsg",
                                        value: item,
                                        expression: "item"
                                      }
                                    ],
                                    staticClass: "last-message"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              item.tags && item.tags.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "uk-margin-medium-top" },
                                    _vm._l(item.tags, function(tag) {
                                      return _c(
                                        "span",
                                        { key: tag, staticClass: "tagAll" },
                                        [
                                          _c(
                                            "el-tag",
                                            { attrs: { size: "mini" } },
                                            [_vm._v(_vm._s(tag))]
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "uk-card-media-left uk-margin-auto-top"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "reservation-main" },
                                  [
                                    _c("reservation-small", {
                                      attrs: {
                                        profile: item.reservationMain || {}
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            ),
            _vm._v(" "),
            _vm.customersLoadMoreLoading
              ? _c("div", { staticClass: "loading-more" }, [
                  _c("i", { staticClass: "fas fa-spinner fa-spin" }),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "font-size": "18px" } }, [
                    _vm._v("Loading more...")
                  ])
                ])
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.searchCustomersMessage.length > 0
      ? _c("div", { attrs: { id: "list-msgCus" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.search != "",
                  expression: "search != ''"
                }
              ],
              staticClass: "header-group"
            },
            [_vm._v("Message")]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "list-group customer-showScoll",
              style: {
                height:
                  _vm.searchCustomersMessage.length > 8 && _vm.search == ""
                    ? _vm.search != ""
                      ? "calc(153vh - 244px)"
                      : "calc(153vh - 200px)"
                    : "calc(77vh - 200px)",
                overflowY:
                  _vm.searchCustomersMessage.length > 8 ? "scroll" : "none"
              }
            },
            _vm._l(_vm.searchCustomersMessage, function(item) {
              return _c(
                "li",
                {
                  key: item.custId,
                  staticClass: "list-group-item",
                  on: {
                    click: function($event) {
                      return _vm.$store.dispatch(
                        "chat/setActiveChatCustumer",
                        item
                      )
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "uk-grid-small uk-flex-middle",
                      attrs: { "uk-grid": "" }
                    },
                    [
                      _c("div", { staticClass: "uk-width-auto" }, [
                        _c("img", {
                          staticClass: "uk-border-circle",
                          staticStyle: { width: "54px", height: "54px" },
                          attrs: {
                            width: "64",
                            height: "64",
                            src:
                              "https://cdnx.softsq.com/thumb/unsafe/84x84/" +
                              encodeURIComponent(
                                encodeURIComponent(item.custImage)
                              ),
                            "data-src": "holder.js/64x64",
                            "data-holder-rendered": "true"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "uk-width-expand" }, [
                        _c("div", {
                          directives: [
                            {
                              name: "time",
                              rawName: "v-time",
                              value: item.latestUpdated,
                              expression: "item.latestUpdated"
                            }
                          ],
                          staticClass: "list-time"
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.count != 0,
                                expression: "item.count != 0"
                              }
                            ],
                            staticClass: "badge msg-unread"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.count) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "h4",
                          {
                            staticClass:
                              "uk-margin-remove-bottom uk-margin-remove-top"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  item.custNameNew == ""
                                    ? item.custName
                                    : item.custNameNew
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("พบ " + _vm._s(item.searchcount) + " ข้อความ")
                        ])
                      ])
                    ]
                  )
                ]
              )
            }),
            0
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loading == false &&
    _vm.searchCustomersMessage.length == 0 &&
    _vm.searchCustomers.length == 0
      ? _c(
          "div",
          { staticClass: "msg-error", attrs: { id: "list-msgCusNotFind" } },
          [_c("span", [_vm._v("ไม่พบการค้นหา")])]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _c("iframe", {
        attrs: { id: "grid1", width: "100px", height: "0px", src: _vm.url }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83d24374", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83d24374","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListChat.vue
// module id = null
// module chunks = 